module.exports = __webpack_public_path__ + "m.no1.186fb473.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/m.no1.jpg
// module id = em7B
// module chunks = 0